import { unparse, UnparseConfig } from "papaparse";

export type ColumnDefinition<T> = {
  key: keyof T;
  label: string;
};

export type CSVExportConfig<T> = {
  filename: string;
  columns: ColumnDefinition<T>[];
};

interface ExportCSVOptions<T> {
  data: T[];
  filename?: string;
  config?: UnparseConfig;
  columns?: ColumnDefinition<T>[];
}

export const exportToCSV = <T>({
  data,
  filename = "export.csv",
  config,
  columns,
}: ExportCSVOptions<T>): void => {
  if (!Array.isArray(data) || data.length === 0) {
    console.warn("exportToCSV: no data to export");
    return;
  }

  try {
    const transformed: unknown[] = columns
      ? data.map((row) =>
          columns.reduce((acc, col) => {
            acc[col.label] = row[col.key];
            return acc;
            //eslint-disable-next-line
          }, {} as Record<string, any>)
        )
      : data;

    const csv = unparse(transformed, config);
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("exportToCSV failed:", error);
  }
};
